export default __webpack_public_path__ + "static/media/LogoReportEnergy.3e46048a.png";